import { useState, useEffect } from 'react';

export function CTASection() {
  const [hours, setHours] = useState(23);
  const [minutes, setMinutes] = useState(59);
  const [seconds, setSeconds] = useState(36);

  useEffect(() => {
    const timer = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else if (minutes > 0) {
        setMinutes(minutes - 1);
        setSeconds(59);
      } else if (hours > 0) {
        setHours(hours - 1);
        setMinutes(59);
        setSeconds(59);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [hours, minutes, seconds]);

  return (
    <section className="relative py-16 sm:py-24 lg:py-32 overflow-hidden bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="absolute inset-0 opacity-5">
        <img
          alt=""
          className="w-full h-full object-cover object-center mix-blend-screen"
          src="https://public.readdy.ai/ai/img_res/82e639a9f62a41e1c5e098a2d4d450f4.jpg"
        />
      </div>
      <div className="absolute bottom-20 right-20 w-64 h-64 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-full blur-3xl opacity-20"></div>
      <div className="absolute bottom-20 right-20 w-80 h-80 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full blur-3xl opacity-20"></div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 text-center">
        <div className="inline-flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2 sm:py-3 rounded-full bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 font-bold mb-6 sm:mb-8 animate-pulse">
          <i className="ri-alarm-warning-line text-xl sm:text-2xl"></i>
          <span className="text-xs sm:text-base lg:text-lg">ÚLTIMA OPORTUNIDAD - OFERTA POR TIEMPO LIMITADO</span>
        </div>

        <h2 className="text-2xl sm:text-3xl lg:text-5xl xl:text-6xl font-extrabold text-white mb-4 sm:mb-6 leading-tight px-2">
          ¿Estás listo para dejar de perder tiempo intentando todo sin resultados?
        </h2>

        <p className="text-base sm:text-lg lg:text-xl xl:text-2xl text-white/80 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-2">
          Esta es tu oportunidad de aprender lo que realmente funciona en marketing digital. Únete ahora y comienza a
          generar ingresos desde el primer día.
        </p>

        <div className="flex justify-center gap-3 sm:gap-4 mb-8 sm:mb-12 px-2">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-6 min-w-[70px] sm:min-w-[100px]">
            <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-1 sm:mb-2">
              {hours.toString().padStart(2, '0')}
            </div>
            <div className="text-white/60 text-xs sm:text-sm font-medium whitespace-nowrap">Horas</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-6 min-w-[70px] sm:min-w-[100px]">
            <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-1 sm:mb-2">
              {minutes.toString().padStart(2, '0')}
            </div>
            <div className="text-white/60 text-xs sm:text-sm font-medium whitespace-nowrap">Minutos</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-3 sm:p-6 min-w-[70px] sm:min-w-[100px]">
            <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-1 sm:mb-2">
              {seconds.toString().padStart(2, '0')}
            </div>
            <div className="text-white/60 text-xs sm:text-sm font-medium whitespace-nowrap">Segundos</div>
          </div>
        </div>

        <div className="space-y-4 sm:space-y-6 px-2">
          <div className="flex items-center justify-center gap-2 sm:gap-3 text-white/80">
            <i className="ri-shield-check-line text-xl sm:text-2xl text-emerald-400"></i>
            <span className="text-xs sm:text-sm">Garantía de satisfacción</span>
          </div>
        </div>

        <div className="mt-12 sm:mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 max-w-4xl mx-auto px-2">
          <div className="flex items-center gap-3 text-white justify-center sm:justify-start">
            <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
              <i className="ri-flashlight-line text-emerald-400 text-xl"></i>
            </div>
            <span className="font-medium text-sm sm:text-base">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-3 text-white justify-center sm:justify-start">
            <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
              <i className="ri-group-line text-emerald-400 text-xl"></i>
            </div>
            <span className="font-medium text-sm sm:text-base">Comunidad exclusiva</span>
          </div>
          <div className="flex items-center gap-3 text-white justify-center sm:justify-start">
            <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
              <i className="ri-medal-line text-emerald-400 text-xl"></i>
            </div>
            <span className="font-medium text-sm sm:text-base">SOPORTE 24/7 DE POR VIDA</span>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 text-white/60 text-xs sm:text-sm px-2">
          <p>✨ Más de 500 estudiantes ya están generando resultados</p>
        </div>

        <div className="mt-12 sm:mt-16 pt-6 sm:pt-8 border-t border-white/20 px-2">
          <p className="text-white/60 text-xs sm:text-sm">© 2026 Esaul Lorenzo. Todos los derechos reservados.</p>
        </div>
      </div>
    </section>
  );
}
